import { useSetAtom } from 'jotai';

import { Card } from '@growtherapy/sprout-ui';

import { NudgeList, NudgeObject, NudgeSchemaTrigger } from '@grow-therapy-team/seedling-components';

import { useTrackEvent } from '../../segment/segment';
import { drawerStateAtom } from '../state';
import { createNudgeOnClickHandlers, getProviderDashboardReferralUri } from './utils';

export interface ClinicalConsiderationsSectionProps {
  nudges: NudgeObject[];
  onClickHandlers?: Partial<Record<NudgeSchemaTrigger, () => void>>;
  isInSessionWithSelectedClient: boolean;
}

export function ClinicalConsiderationsSection({
  nudges,
  onClickHandlers,
  isInSessionWithSelectedClient,
}: ClinicalConsiderationsSectionProps) {
  return (
    <div className='flex flex-col mb-6 gap-y-6' data-testid='clinical-considerations-section.body.content'>
      <Card title='Clinical considerations' data-testid='clinical-considerations-section.card.content'>
        <NudgeList
          nudges={nudges}
          onClickHandlers={onClickHandlers || undefined}
          context={isInSessionWithSelectedClient ? 'telehealth-session' : 'telehealth-waiting-room'}
        />
      </Card>
    </div>
  );
}

export function ClinicalConsiderationsSectionWrapper({
  nudges,
  patientId,
  isInSessionWithSelectedClient,
}: {
  nudges: NudgeObject[];
  patientId: string;
  isInSessionWithSelectedClient: boolean;
}) {
  const { userClicked } = useTrackEvent();
  const onClickHandlers = createNudgeOnClickHandlers(
    nudges,
    useSetAtom(drawerStateAtom),
    getProviderDashboardReferralUri(patientId),
    userClicked,
    isInSessionWithSelectedClient,
  );

  return (
    <ClinicalConsiderationsSection
      nudges={nudges}
      onClickHandlers={onClickHandlers}
      isInSessionWithSelectedClient={isInSessionWithSelectedClient}
    />
  );
}
